import { apiClient } from "./ApiClient";

export async function validateVoucher(code) {
  if (!code || code.trim() === "") {
    return { available: false };
  }

  try {
    const response = await apiClient.get(`/promocode/available/${encodeURIComponent(code.trim())}`);
    return {
      available: response.data.available,
      promocode: response.data.promocode,
      user_activations_left: response.data.user_activations_left,
    };
  } catch (error) {
    const status = error.response?.status || error.request?.status;
    const errorData = error.response?.data || {};

    const err = new Error(errorData.detail || "Voucher validation failed");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function fetchPromocodesAdmin({ skip, limit, sort_by, sort_order, filters }) {
  const params = new URLSearchParams({
    skip: skip.toString(),
    limit: limit.toString(),
    sort_by,
    sort_order,
  });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      params.append(key, filters[key]);
    }
  }

  try {
    const response = await apiClient.get(`/promocode/batch?${params}`);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status;

    const err = new Error(errorData.detail || `Failed to fetch promocodes`);
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function createPromocode({
  type,
  amount,
  currency,
  date_end,
  activations_left,
  user_activation_count,
  code,
}) {
  try {
    const payload = {
      type,
      amount,
      currency,
      date_end,
      activations_left,
      user_activation_count,
      code,
    };

    const response = await apiClient.post("/promocode/", payload);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to create promocode");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function updatePromocode(id, data) {
  try {
    const response = await apiClient.put(`/promocode/${id}`, data);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to update promocode");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function deletePromocode(id) {
  try {
    const response = await apiClient.delete(`/promocode/${id}`);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to delete promocode");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}
